import React from 'react';

export default {
  path: 'day',
  view: 'day',
  component: () => <div>Not Implemented</div>,
};



// WEBPACK FOOTER //
// ./containers/Group/ProgressTest/ProgressTestDayView/routes.jsx